import React from 'react';
import {DetailModal} from '../../components/panels/marketStatusTraderUpdates.panel.tsx';

export const marketStatusTraderUpdatesPanelColumnDefs = [
    {
        cellRendererFramework: ({data}) => <DetailModal {...data} />,
        field: '_details_',
        headerName: '',
        pinned: 'left',
        sortable: false,
        width: 15
    },
    {
        field: 'date',
        headerName: 'Date',
        sortable: false,
        width: 80
    },
    {
        field: 'description',
        headerName: 'Description',
        sortable: false,
        width: 250
    },
    {
        field: 'market',
        headerName: 'Market',
        sortable: false,
        width: 200
    },
    {
        field: 'service',
        headerName: 'Service',
        sortable: false,
        width: 50
    }
];
